import { useEffect, useState } from "react";
import api from "@/lib/api";
import MatchCard from "@/components/MatchCard";
import Pickems from "@/components/Pickems";
import Streamers from "@/components/Streamers";
import { useUiTexts } from "@/lib/uiTexts";

const FILTERS = [
  { key: "all", label: "Tous les matchs", testid: "results-filter-all" },
  { key: "League of Legends", label: "League of Legends", testid: "results-filter-lol" },
  { key: "Teamfight Tactics", label: "Teamfight Tactics", testid: "results-filter-tft" },
  { key: "Rainbow Six Siege", label: "Rainbow Six Siege", testid: "results-filter-r6" },
];

export default function Results() {
  const texts = useUiTexts();
  const [matches, setMatches] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/matches").then((r) => setMatches(r.data)).catch(() => {});
  }, []);

  const visible = filter === "all" ? matches : matches.filter((m) => m.game === filter);

  return (
    <div data-testid="results-page" className="page-enter mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">{texts.results_label}</p>
      <h1 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl">{texts.results_title}</h1>

      <Streamers />

      <h2 className="mt-16 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">Matchs</h2>
      <div className="mt-6 flex flex-wrap gap-3">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} data-testid={f.testid}
            className={`rounded-lg border px-4 py-2 font-heading text-sm font-bold uppercase tracking-wide transition-all hover:scale-[1.02] active:scale-[0.98] ${
              filter === f.key ? "glow-orange border-orange-500 bg-orange-500 text-[#060B18]" : "border-orange-500/30 text-slate-300 hover:bg-orange-500/10"
            }`}>
            {f.key === "all" ? texts.results_filter_all : f.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {visible.map((m) => <MatchCard key={m.id} match={m} />)}
      </div>
      {visible.length === 0 && <p className="mt-10 text-slate-500">{texts.results_empty}</p>}

      <Pickems />
    </div>
  );
}
